import { Box, Text } from '@radix-ui/themes';

import { PropsWithChildren } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './DataLoaderWrapper.module.css';

interface DataLoaderWrapperProps extends PropsWithChildren {
    isLoading: boolean;
    isError: boolean;
}

export const DataLoaderWrapper = ({
    isError,
    isLoading,
    children,
}: DataLoaderWrapperProps) => {
    useTranslation();

    if (isLoading) {
        return (
            <Box className={styles.loadingContainer}>
                <Text>
                    <Trans i18nKey={'messages.loading_data'} />
                </Text>
            </Box>
        );
    }

    if (isError) {
        return (
            <Box className={styles.errorContainer}>
                <Text>
                    <Trans i18nKey={'messages.loading_data_error'} />
                </Text>
            </Box>
        );
    }

    return <>{children}</>;
};
